export const state = () => {
	return {
		currencies: [],
	}
}

export const actions = {
	async list({ commit }, { companyId, challengeId }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/loyalty/challenge-currency/?challenge=${challengeId}`)
			.then((currencies) => {
				commit('setCurrencies', { currencies })
				return currencies
			})
			.catch((err) => {
				throw err
			})
	},

	async create({ dispatch }, { companyId, currency }) {
		const created = await useNuxtApp().$api(
			`api/company/${companyId}/loyalty/challenge-currency/`,
			{
				method: 'POST',
				body: currency,
			},
		)
		dispatch('list', { companyId, challengeId: currency.challenge }, true)
		return created
	},

	async partialUpdate(_, { companyId, currency }) {
		const { id, challenge_id, ...data } = currency
		const patched = await useNuxtApp().$api(
			`api/company/${companyId}/loyalty/challenge-currency/${id}/`,
			{
				method: 'PATCH',
				body: {
					challenge: challenge_id,
					...data,
				},
			},
		)
		return patched
	},

	async remove({ dispatch }, { companyId, currency }) {
		const { id, challenge_id } = currency
		const deleted = await useNuxtApp().$api(
			`api/company/${companyId}/loyalty/challenge-currency/${id}/`,
			{
				method: 'DELETE',
			},
		)

		dispatch('list', { companyId, challengeId: challenge_id }, true)
		return deleted
	},
}

export const mutations = {
	setCurrencies(state, { currencies }) {
		state.currencies = currencies
	},
}
